var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLivingRoomMode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "824px",
    height: "824px",
    viewBox: "0 0 824 824",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "living_room_mode") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "living_room_mode",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(284.000000, 284.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256,128 C256,57.3091701 198.69083,0 128,0 C57.3091701,0 0,57.3091701 0,128 C0,198.69083 57.3091701,256 128,256 C198.69083,256 256,198.69083 256,128 Z",
    id: "changeStroke",
    stroke: "#222222",
    strokeWidth: 10,
    fill: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.931517,115.2 L84.0684835,115.2 C82.6287754,115.2 81.4545455,114.107607 81.4545455,112.768237 L81.4545455,71.0768089 C81.4545455,69.7469388 82.6287754,68.6545455 84.0684835,68.6545455 L171.931517,68.6545455 C173.371225,68.6545455 174.545455,69.7469388 174.545455,71.0768089 L174.545455,112.768237 C174.545455,114.107607 173.371225,115.2 171.931517,115.2 Z",
    id: "changeStroke",
    stroke: "#222222",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "changeStroke",
    stroke: "#222222",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "58.1818182 186.181818 58.1818182 150.109091 197.818182 150.109091 197.818182 186.181818"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "changeFill",
    fill: "#222222",
    cx: 128,
    cy: 132.654545,
    r: 5.81818182
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivingRoomMode);
export default __webpack_public_path__ + "static/media/living_room_mode.957ec6f580046715e99199f36df15e3a.svg";
export { ForwardRef as ReactComponent };